import { render } from "./pendingFaultComponent.vue?vue&type=template&id=4321ce64&scoped=true"
import script from "./pendingFaultComponent.vue?vue&type=script&lang=js"
export * from "./pendingFaultComponent.vue?vue&type=script&lang=js"

import "./pendingFaultComponent.vue?vue&type=style&index=0&id=4321ce64&lang=scss&scoped=true"

import exportComponent from "G:\\frontend\\dse-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4321ce64"]])

export default __exports__